<template>
  <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-primary">
    <!-- Sidebar toggler (only if logged in) -->
    <div class="container-fluid">
      <button v-if="store.state.user?.email" class="navbar-toggler" type="button" aria-label="Toggle navigation" @click="toggleSidebar">
        <span class="navbar-toggler-icon"></span>
      </button>

      <i class="bi bi-clock text-white"></i>

      <router-link class="navbar-brand title-left" to="/">
        {{ appTitle }} {{ pageTitle }} <span class="badge bg-warning text-dark">{{ environment }}</span>
      </router-link>
      <ul class="navbar-nav d-none d-sm-flex ms-auto">
        <li class="nav-item" v-if="store.state.user.email">
          <a class="nav-link dropdown-toggle text-light" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">{{ store.state.user.email }}</a>
          <ul id="nav-user-menu" class="dropdown-menu">
            <li>
              <router-link to="/profile" class="dropdown-item"><i class="bi bi-person"></i> Profile</router-link>
            </li>
            <li><hr class="dropdown-divider" /></li>
            <li>
              <a href="#" class="dropdown-item" @click="logOut"><i class="bi bi-unlock"></i> Log Out</a>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-if="!store.state.user.email">
          <router-link to="/login" class="nav-link text-light"><i class="bi bi-lock"></i> Log In</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { computed, ref, inject } from "vue";
import router from "@/router";
import * as _config from "@/config";
import * as _securityService from "@/services/securityService";

export default {
  name: "cNav",
  setup() {
    const store = inject("store");
    function toggleSidebar() {
      c8.toggleClassById("side-bar", "show");
    }

    const currentRoute = router;
    const logOut = function () {
      _securityService.logOut().then((response) => {
        if (response.success) {
          store.dispatch("logOut").then((r) => {
            currentRoute.push("/login");
          });
        }
      });
    };

    const appTitle = computed(() => {
      return _config.appTitle;
    });
    const environment = computed(() => {
      let e = store.state.user.environment;
      return e ? (e.toLowerCase() == "production" ? "" : `(${e})`) : "";
    });
    const pageTitle = computed(() => {
      return currentRoute.currentRoute.value.meta ? currentRoute.currentRoute.value.meta.title : "";
    });
    return { appTitle, currentRoute, environment, pageTitle, toggleSidebar, logOut, store };
  },
};
</script>

<style>
img.logo {
  height: 40px;
  /* margin: -5px; */
}
.navbar-brand.title-left {
  position: absolute;
  left: 105px;
}
</style>
